<template>
  <LcRadioCard :label="bankName" label-class="paragraph-bold" :value="id">
    <template #default>
      <PaymentMethodSymbol variant="Aeropay" />
    </template>

    <template #bottom>
      <PayoutStoredMethodAeropayTag>
        <p>{{ bankAccountName }}</p>
      </PayoutStoredMethodAeropayTag>
    </template>
  </LcRadioCard>
</template>

<script setup lang="ts">
import type { PayOutAccountAeropay } from '../../../../../core/api/shared/@types/generated/backend/graphql-schema-types'

type PayoutStoredMethodAeropayProps = Omit<PayOutAccountAeropay, '__typename'>

defineProps<PayoutStoredMethodAeropayProps>()
</script>
